import React from 'react';
import { useTranslation } from 'react-i18next';

import { SettingsPanel } from '../../settings/settings-panel/settings-panel';
import { SettingsPanelPlacement } from '../../settings/settings-panel/use-settings-panel';
import { ToolIcon } from '../../tool-icon';
import { ViewSettingsPanel } from './view-settings-panel';

type Props = {
  toolbarRef: React.RefObject<HTMLElement>;
  /** Where the settings open, see useSettingsPanel. */
  placement?: SettingsPanelPlacement;
};

/**
 * The settings for the views and their layers (SK-7549-view-settings), replacing the point cloud's
 * own cog.
 */
const ViewSettingsTool = (props: Props) => {
  const { t } = useTranslation();
  const [settingsOpen, setSettingsOpen] = React.useState(false);

  return (
    <SettingsPanel
      content={<ViewSettingsPanel />}
      mainAxisOffset={15}
      placement={props.placement}
      toolbarRef={props.toolbarRef}
      onToggle={setSettingsOpen}
    >
      <ToolIcon
        active={settingsOpen}
        icon={['fal', 'layer-group']}
        tooltip={
          settingsOpen
            ? undefined
            : {
                title: t('viewSettings.tooltip.title', { ns: 'skyviewToolbar' }),
                text: t('viewSettings.tooltip.text', { ns: 'skyviewToolbar' }),
              }
        }
      />
    </SettingsPanel>
  );
};

export { ViewSettingsTool };
